import React, { useState } from 'react';
import TextBlock from 'components/common/helpMeDecide/TextBlock';
import withCriteria from 'components/common/helpMeDecide/withCriteria';
import { Guideline, RadioGroup } from '@insurancemenu/imenu-components-lib';
import { createStyles } from 'components/common/helpMeDecide/commonCriteriaStyles';
import ActionModal from 'components/common/modals/ActionModal';
import { ModalType } from 'global/utils/ModalsHelper';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { toJS } from 'mobx';

const DentalCriteria1 = observer((): JSX.Element => {
  const [showWarningModal, setShowWarningModal] = useState(false);

  const classes = createStyles();

  // Mobx store
  const {
    browsingStore: { productLines, cart, setCurrentProductLineId },
    browsingCriteriaModalStore: { openBrowsingCriteriaModal },
    browsingFilterStore: { onBooleanCheckboxFilterChange, getFilterBooleanCheckboxValue },
  } = useRootStore();

  const convertedProductLines = productLines.map((line) => toJS(line)).slice();
  const convertedCart = toJS(cart);

  const filterName = 'ACA';

  const openBcModal = (): void => {
    const selectedProductLineId = 'GroupDental';

    setCurrentProductLineId(selectedProductLineId);
    const pLine = convertedProductLines.find((line) => line.productLineId === selectedProductLineId);
    void openBrowsingCriteriaModal(
      convertedCart,
      selectedProductLineId,
      pLine?.eStoreBcFormId || pLine?.bcFormId || '',
    );
  };

  // Values for radio buttons group
  const radioButtons = [
    {
      id: 'ACA',
      label: 'Yes, only show me plans that have ACA coverage',
      value: 'ACA',
    },
    {
      id: 'all',
      label: 'Show me all options',
      value: 'all',
    },
  ];

  return (
    <div>
      <TextBlock
        title="Choose ACA Coverage"
        subtitle="Delta Dental gives you the flexibility to offer plans with or without the Affordable Care Act’s (ACA) pediatric dental benefit."
      />
      <RadioGroup
        label=""
        value={getFilterBooleanCheckboxValue(filterName, filterName)}
        radioButtons={radioButtons}
        className={classes.radioButtonGroup}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
          onBooleanCheckboxFilterChange(filterName, e.target.value);
          if (e.target.value === filterName) {
            setShowWarningModal(true);
          }
        }}
      />
      <Guideline
        simpleStyles
        labels={{
          opened: 'Learn more about the ACA pediatric dental benefit',
          closed: 'Learn more about the ACA pediatric dental benefit',
        }}
        className={classes.guidelineWrapper}
        content={
          <ul className={classes.guidelineList}>
            <li className={classes.guidelineItem}>
              Plans with the ACA benefit will have one benefit for adults (21+) and one benefit for children.
            </li>
            <li className={classes.guidelineItem}>
              The ACA defines the pediatric dental benefit as one of the 10 essential health benefits, but is not
              required.
            </li>
          </ul>
        }
      />
      <ActionModal
        show={showWarningModal}
        title="You have selected to only view plans with ACA coverage."
        subtitle="Delta Dental offers one plan design with your choice of network and optional orthodontia coverage. You will now be directed to the browse page to see these plan options."
        closeButtonText="Cancel"
        onClose={(): void => {
          setShowWarningModal(false);
          onBooleanCheckboxFilterChange(filterName, 'all');
        }}
        modalType={ModalType.NOTIFICATION}
        actionButtonText="Continue"
        onAction={(): void => {
          setShowWarningModal(false);
          openBcModal();
        }}
      />
    </div>
  );
});

export default withCriteria(DentalCriteria1, 1);
